<template>
  <div id="bk-asiacity-tavolos-widget">
    <div class="book-with-bk">
      <div class="book-with-bk-logo">
        <span>Book with </span><span><img :src="logo_src"></span>
      </div>
      <hr class="book-with-bk-line">
    </div>
    <transition name="tavolos-slide-right-fade" mode="out-in">
      <Book :restaurant_id="restaurant_id" :publisher_id="publisher_id"></Book>
    </transition>
  </div>
</template>

<script>

  import Book from './Book.vue'

  export default {
    components: {
      Book
    },
    data () {
      return {
        logo_src: 'https://widget.tavolos.com/src/assets/publisher/' + this.publisher_id + '.png',
      }
    },

    props: [
      'restaurant_id',
      'publisher_id'
    ],
  }
</script>

<style lang="scss">


  #bk-asiacity-tavolos-widget  {
    position: relative;
    padding: 0;
    width: 100%;
    margin: 0 auto 30px auto;
    .book-with-bk {
      text-align: center;
      height: 54px;
    }
    .book-with-bk-logo {
      background: #fff;
      padding: 0 15px;
      display: inline-block;
      span {
        display: inline-block;
        font-size: 24px;
        font-weight: bold;
        vertical-align: middle;
      }
      img {
        position: relative;
        display: block;
        background: #fff;
        height: 32px !important;
        width: auto !important;
        margin-left: 10px;
      }
    }

    hr.book-with-bk-line {
      margin: 0;
      margin-top: -18px;
      border: 0;
      border-top: 1px solid #000;
    }
  }


  @media (max-width: 767px) {
    #bk-asiacity-tavolos-widget {
      padding: 0 15px;
      width: auto;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/BKAsiaCity.vue